 function shakeButton() {
    setTimeout(function() {
        $(".product-form__cart-submit").addClass("shake");
        shakeButton();
      // Shakes every 6 seconds
    }, 6000);
    setTimeout(function() {
        $(".product-form__cart-submit").removeClass("shake");
        
    }, 1500)
}

shakeButton();